import axios from "axios";

const user = JSON.parse(localStorage.getItem('user'))
const ANDROID = 'kkppdg';
const PASSWORD = 'ppid@KKPpadang';
export const Authorization = 'Basic '+window.btoa(ANDROID+":"+PASSWORD);
const header = {
    "Content-type":"application/json",
    "Authorization" : Authorization
} 
if (user && user.accessToken){
    header.Authorization = 'Bearer ' + user.accessToken
} 
export default axios.create({
    baseURL:"http://ppid.bkkpadang.id:8080/api",
    headers:header
});